<template>
<div>
  <div>
    <h1 style='text-align:center;margin-top: 2em;'>Bienvenue {{info.prenom||""}} {{info.nom||""}}</h1>
    <h4 style='text-align:center;'>Vous trouverez ici votre document unique.</h4>
    <div v-if="info.logo" class="logoEntreprise" style="margin-top:5em;">
      <img :src="'/api/logoClient?v='+info.id" alt=""/>
    </div>
  </div>
</div>
</template>

<script>
import script from '../../script/script.js';

export default {
  data() {
    return {
    }
  },
  mounted:function(){
    this.verifyRight();
    this.loadingInfoClient();
  },
  methods: {
    verifyRight: script.verifyRight,
    loadingInfoClient: script.loadingInfoClient,
  },
  computed:{
    info(){
      return this.$store.state.info
    }
  }
  
}
</script>

<style>
.logoEntreprise{
  text-align: center;
}

.logoEntreprise > img{
  width: 20%;
}
</style>
